import ProblemsList from "./ProblemsList";

function LatestFreeQuestions() {
  return (
    <section className="last-problem-parent">
        <div className="container">
            <h3 className="mainHeader text-center">Najnowsze nieodpłatne pytania do prawników</h3>
            <ProblemsList />
        </div>
    </section>
  )
}

export default LatestFreeQuestions;